import Section from "./Section";
const PrivacyPolicy = () => {
  return (
    <Section>
      <meta
        name="title"
        content="Privacy Policy - Protecting Your Data and Information"
      />
      <meta
        name="description"
        content="Read our Privacy Policy to learn how we collect, use, and protect your personal information. Your privacy matters to us, and we are committed to safeguarding your data responsibly."
      />
      <meta
        name="keywords"
        content="privacy policy, data protection, information security, personal information, user privacy, data collection, privacy rights"
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://www.bafarlabs.com/privacy-policy" />
      <title>Privacy Policy - Protecting Your Data and Information</title>
      <div className="container mx-auto overflow-hidden px-4 py-8 pt-[4.75rem] md:max-w-[70vw] lg:pt-[5.25rem]">
        <h1 className="mb-6 text-center text-3xl font-bold">Privacy Policy</h1>

        <p className="mb-4 text-lg">
          At Bafar Labs, we value your privacy. This Privacy Policy outlines the
          types of information we collect from users, how we use it, and how we
          protect your data. By using our services, you agree to the collection
          and use of information in accordance with this policy.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          1. Information We Collect
        </h2>
        <p className="mb-4 text-lg">
          We collect information that you provide to us directly, such as when
          you sign up for our services, fill out forms on our website, or
          contact us. This may include personal information such as your name,
          email address, and phone number.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          2. How We Use Your Information
        </h2>
        <p className="mb-4 text-lg">
          The information we collect is used to provide, improve, and
          personalize our services. It may also be used for communication
          purposes, such as sending updates, promotional content, or customer
          support inquiries.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">3. Data Security</h2>
        <p className="mb-4 text-lg">
          We are committed to protecting your personal information. We implement
          various security measures to ensure that your data is protected from
          unauthorized access, alteration, or disclosure.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">4. Cookies</h2>
        <p className="mb-4 text-lg">
          Our website uses cookies to enhance the user experience. Cookies are
          small files stored on your device that allow us to remember your
          preferences and improve site functionality.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          5. Third-Party Services
        </h2>
        <p className="mb-4 text-lg">
          We may use third-party services to assist with various functions of
          our website, such as analytics, advertising, and payment processing.
          These services may collect information about your interaction with our
          site.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">6. Your Rights</h2>
        <p className="mb-4 text-lg">
          You have the right to access, update, or delete your personal
          information at any time. If you wish to exercise these rights, please
          contact us using the contact information provided below.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">
          7. Changes to This Privacy Policy
        </h2>
        <p className="mb-4 text-lg">
          We reserve the right to update or modify this Privacy Policy at any
          time. We will notify you of any significant changes by posting the
          updated policy on this page.
        </p>

        <h2 className="mb-4 mt-6 text-2xl font-semibold">8. Contact Us</h2>
        <p className="mb-4 text-lg">
          If you have any questions or concerns regarding this Privacy Policy,
          please contact us at{" "}
          <a href="mailto:info@bafarlabs.com" className="text-blue-600">
            info@bafarlabs.com
          </a>
          .
        </p>
      </div>
    </Section>
  );
};

export default PrivacyPolicy;
